import React from "react";
import { Input, Label } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import styles from "../../styles.scss";
import SectionLabel from "../../common/sectionLabel";
import { POST_DETAIL_LAYOUT } from "../../../../constants";

export interface PostDetailLayoutPanelProps {
  layout: string;
  onLayoutChange: (layout: string) => void;
}

const LAYOUT_OPTIONS = [
  {
    value: POST_DETAIL_LAYOUT.CENTERED,
    label: "Post only",
  },
  {
    value: POST_DETAIL_LAYOUT.LATEST_NEWS,
    label: "Latest News",
  },
  {
    value: POST_DETAIL_LAYOUT.BIO,
    label: "Bio and Picture",
  },
] as const;

const PostDetailLayoutPanel = ({
  layout,
  onLayoutChange,
}: PostDetailLayoutPanelProps) => (
  <div className={styles.layoutRadioGroup}>
    <SectionLabel
      label="Post detail layout"
      tooltip="Choose how the post detail page is arranged"
    />
    {LAYOUT_OPTIONS.map(option => (
      <div key={option.value} className={styles.layoutRadioOption}>
        <Label check className={styles.layoutRadioLabel}>
          <Input
            type="radio"
            name="postDetailLayout"
            className={styles.radioInput}
            checked={layout === option.value}
            onChange={() => onLayoutChange(option.value)}
          />
          <span className={styles.radioText}>{option.label}</span>
        </Label>
      </div>
    ))}
  </div>
);

export default withStyles(styles)(PostDetailLayoutPanel);
